import { Playground } from '@playground';
import { Header } from "../../../../../packages/layout/src/components/header/header";
import { Highlight } from "../../../../../packages/layout/src/components/highlight/highlight";
import * as React from 'react';
export default {
  Playground,
  Header,
  Highlight,
  React
};